// extracted by mini-css-extract-plugin
export default {"title":"title__1DPwY","card":"card__1Wu6b","icon":"icon__2Fq5U","item":"item__39w74","desc":"desc__1Ywvp","layer":"layer__1mT7W","role":"role__3sGHF"};